import { useEffect, useState } from "react";
import { Loader2, MailCheck } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Checkbox } from "../ui/checkbox";
import { api, formatApiError } from "../../lib/api";

export const OtpForm = ({ challenge, onVerify, onBack }) => {
  const [code, setCode] = useState("");
  const [trust, setTrust] = useState(true);
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [loading, setLoading] = useState(false);
  const [wait, setWait] = useState(60);
  useEffect(() => {
    if (wait <= 0) return undefined;
    const t = setTimeout(() => setWait((w) => w - 1), 1000);
    return () => clearTimeout(t);
  }, [wait]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await onVerify(code, trust);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };
  const resend = async () => {
    setError("");
    try {
      const { data } = await api.post("/auth/login/resend-otp", { challengeId: challenge.challengeId });
      setInfo(`Kode baru dikirim ke ${data.email}.`);
      setWait(60);
    } catch (err) {
      setError(formatApiError(err));
    }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="otp-form">
      <div className="flex gap-3 rounded-lg bg-emerald-50 border border-emerald-200 p-3 text-sm text-emerald-900" data-testid="otp-info">
        <MailCheck className="h-5 w-5 shrink-0" />
        <p>Perangkat ini belum dikenali. Kode verifikasi 6 angka telah dikirim ke <b>{challenge.email}</b> dan berlaku {challenge.expiresInMinutes} menit.</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="otp">Kode Verifikasi</Label>
        <Input id="otp" required inputMode="numeric" autoComplete="one-time-code" maxLength={6} pattern="\d{6}" value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} className="h-11 bg-white tracking-[0.5em] text-lg font-semibold" data-testid="otp-code-input" />
      </div>
      <label className="flex items-start gap-2 text-sm text-slate-700">
        <Checkbox checked={trust} onCheckedChange={(v) => setTrust(!!v)} data-testid="otp-trust-checkbox" />
        <span>Percayai perangkat ini selama 30 hari. Jangan centang jika ini komputer umum atau milik orang lain.</span>
      </label>
      {info && <p className="text-sm text-emerald-800" data-testid="otp-resend-info">{info}</p>}
      {error && <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md p-2" data-testid="otp-error">{error}</p>}
      <Button type="submit" disabled={loading || code.length !== 6} className="w-full h-11 bg-emerald-800 hover:bg-emerald-900" data-testid="otp-submit-btn">
        {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Verifikasi & Masuk
      </Button>
      <div className="flex justify-between text-xs font-semibold">
        <button type="button" onClick={onBack} className="text-slate-600" data-testid="otp-back-btn">Kembali</button>
        <button type="button" disabled={wait > 0} onClick={resend} className="text-emerald-800 disabled:text-slate-400" data-testid="otp-resend-btn">
          {wait > 0 ? `Kirim ulang kode (${wait} dtk)` : "Kirim ulang kode"}
        </button>
      </div>
    </form>
  );
};
